export function getFloorLabel(level) {
  return `${level.display_name || `${level.floor_number === 0 ? 'Ground floor' : `Floor ${level.floor_number}`}${level.display_name ? ` - ${level.display_name}` : ''}`}`
}

// Design layouts belong to the unit type; a floor shows apartment-wide rows (unit_type_level_id null) and its own legacy rows
export function getLevelDesignLayouts(unitType, levelId) {
  return (unitType?.design_layouts || [])
    .filter((d) => !d.is_deleted && (d.unit_type_level_id == null || d.unit_type_level_id === levelId))
    .map((d) => (d.room_designs ? { ...d, room_designs: d.room_designs.filter((rd) => !rd.room || rd.room.unit_type_level?.id === levelId) } : d))
}

export function getUnitTypeDesignLayouts(unitType) {
  return (unitType?.design_layouts || []).filter((d) => !d.is_deleted)
}
